(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["miw-poem-viewer"] && !Shopify.designMode) return;
  try {
    (() => {
 const dialog=document.getElementById('miw-poem-viewer');
 if(!dialog)return;
 const image=dialog.querySelector('img'),pane=dialog.querySelector('.miw-viewer-scroll'),zoom=dialog.querySelector('[data-miw-zoom]');
 let opener,scrollY=0,oldOverflow='';
 const isPoem=img=>/miw-poem-card|詩卡|中日對照|日文原詩/.test((img.getAttribute('src')||'')+' '+(img.alt||''));
 function prepare(){
  document.querySelectorAll('main img,.miw-guide img').forEach(img=>{
   if(!isPoem(img)||dialog.contains(img))return;
   const a=img.closest('a');
   const trigger=a||img;trigger.dataset.miwPoem='true';trigger.setAttribute('aria-haspopup','dialog');
   if(a)a.removeAttribute('target');else{trigger.tabIndex=0;trigger.setAttribute('role','button');trigger.setAttribute('aria-label','放大詩卡：'+img.alt);}
  });
 }
 function open(trigger){
  const img=trigger.matches('img')?trigger:trigger.querySelector('img');if(!img)return;
  let src=img.currentSrc||img.src;
  if(trigger.matches('a')){const u=new URL(trigger.href,location.href);if(/\.(png|jpe?g|webp)(\?|$)/i.test(u.href))src=u.href;}
  opener=trigger;scrollY=window.scrollY;oldOverflow=document.body.style.overflow;
  image.src=src;image.alt=img.alt;pane.classList.remove('is-zoomed');zoom.textContent='放大文字';
  dialog.showModal();document.body.style.overflow='hidden';pane.scrollTop=0;pane.scrollLeft=0;
 }
 document.addEventListener('click',e=>{
  const trigger=e.target.closest('[data-miw-poem]');
  if(trigger){e.preventDefault();e.stopPropagation();open(trigger);return;}
  const a=e.target.closest('a');if(!a)return;
  if(location.pathname==='/pages/morita-miw-poetry'&&new URL(a.href,location.href).pathname.includes('/blogs/')){
   try{sessionStorage.setItem('miw-guide-return',JSON.stringify({y:window.scrollY,time:Date.now()}));}catch(_){}
  }
 },true);
 document.addEventListener('keydown',e=>{const t=e.target.closest('[data-miw-poem]');if(t&&!t.matches('a')&&(e.key==='Enter'||e.key===' ')){e.preventDefault();open(t);}});
 dialog.querySelector('[data-miw-close]').addEventListener('click',()=>dialog.close());
 dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
 zoom.addEventListener('click',()=>{const on=pane.classList.toggle('is-zoomed');zoom.textContent=on?'適合畫面':'放大文字';});
 dialog.addEventListener('close',()=>{document.body.style.overflow=oldOverflow;if(opener)opener.focus({preventScroll:true});window.scrollTo({top:scrollY,behavior:'instant'});});
 prepare();document.addEventListener('shopify:section:load',prepare);
 const params=new URLSearchParams(location.search);
 if(location.pathname==='/pages/morita-miw-poetry'&&params.has('miw_return')){
  let saved;try{saved=JSON.parse(sessionStorage.getItem('miw-guide-return'));}catch(_){}
  if(saved&&Date.now()-saved.time<86400000){
   const restore=()=>window.scrollTo({top:saved.y,behavior:'instant'});
   if(document.readyState==='complete')restore();else window.addEventListener('load',restore,{once:true});
   params.delete('miw_return');history.replaceState(null,'',location.pathname+(params.toString()?'?'+params:''));
  }
 }
})();
  } catch(e) { console.error(e); }
})();

})();
